import vasadu from 'vasadu';

const localizationData = {
  MENU_ABOUT: {
    no: 'om MITT VALG!'
  },
  MENU_LIBRARY: {
    no: 'Mitt bibliotek'
  },
  MENU_PARTS: {
    no: 'Deloversikt'
  },
  MENU_MY_PAGE: {
    no: 'Min side'
  },
  MENU_CONTACT: {
    no: 'Kontakt'
  },
  LOGOUT_LABEL: {
    no: 'Logg ut'
  },
  CHAPTER_REFLECTION_TITLE: {
    no: 'Refleksjon'
  },
  CHAPTER_REFLECTION_PLACEHOLDER: {
    no: 'Skriv dine refleksjoner her.'
  },
  REFLECTION_BUTTON_LABEL: {
    no: 'Reflekter'
  },
  CANCEL_LABEL: {
    no: 'Avbryt'
  },
  CLOSE_LABEL: {
    no: 'Lukk'
  }
};

const localization = vasadu(localizationData, 'no');

export default localization;



// WEBPACK FOOTER //
// ./src/utils/locale.js